import React from 'react'

import { FormikType } from 'features/project-form/features/source/components/NewSource'
import * as sources from 'features/project-form/features/source/components/sources'

export type SourceProps = {
  sourceType: string
  formik: FormikType
}

const { File, Url, Amazon, ...sourceList } = sources as Record<
  string,
  React.ComponentType<SourceProps>
>

export { Amazon, File, sourceList, Url }

export const customSources = Object.keys(sourceList)
